import React, { Component, Fragment } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import Main from '../Main/Main';

class StatsPage extends Component {
  render() {
    return (
      <Fragment>
        <Sidebar highlightNavItemIndex={4} />
        <Topbar>Topbar StatsPage</Topbar>
        <Main>Main StatsPage</Main>
      </Fragment>
    );
  }
}

export default  StatsPage;
